import initializeBootLocalization from 'mini-boot-localization/lib/initializeBootLocalization';
import { getWindowTitle } from 'mini-window-title/lib/getWindowTitle';
import { initializeAppState } from './initialization/initializeAppState';
import { initializeFontScale } from './initialization/initializeFontScale';
import { initializeManifest } from './initialization/initializeManifest';
import { initializeTheme } from './initialization/initializeTheme';
import { MiniErrorComponentAsync } from 'mini-error-component';
import { sharedBootstrap } from 'mini-shared-bootstrap';
import type { BootstrapOptions } from './types/BootstrapOptions';
import type { SessionData } from 'owa-service/lib/types/SessionData';

/**
 * Extend the shared-bootstrap to perform mini specific boot operations
 * @param options
 */
export function bootstrap(options: BootstrapOptions) {
    return sharedBootstrap({
        ...options,
        initializeState: (sessionData?: SessionData) => {
            const statePromises = [];
            const commonInitPromise = initializeAppState();
            const initializeThemePromise = initializeTheme();
            statePromises.concat([commonInitPromise, initializeThemePromise]);

            initializeManifest();

            // Initialize font scale here instead of setUpSharedPostBoot as it is quicker and provides a better UX
            initializeFontScale();

            const originalPromise = options.initializeState(sessionData);
            if (originalPromise) {
                statePromises.push(originalPromise);
            }
            return Promise.all(statePromises);
        },
        getWindowTitle: () => getWindowTitle(options.getModuleName()),
        initializeLocalization: initializeBootLocalization(options.workload),
        fullErrorComponent: MiniErrorComponentAsync,
    });
}
